import { Anchor, Button } from '@mantine/core'
import { IconExternalLink, IconMessageCircle } from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/fr'
import Breadcrumbs from '@/components/ui/Breadcrumbs'
import Table from '@/components/ui/table/Table'
import { CANCELLATION_REASONS } from '@/lib/cancellationReasons'
import CancellationOrderDetails from '@/components/orders/CancellationOrderDetails'

dayjs.extend(relativeTime)

function CancellationRequestCell(order) {
    return (
        <div className="table-cell px-5 py-3 align-top min-w-[240px] max-w-[420px]">
            <time
                className="mb-1 block text-sm font-medium text-gray-800"
                dateTime={order.cancellation_requested_at}
                title={dayjs(order.cancellation_requested_at).locale('fr').format('D MMMM YYYY [à] HH:mm')}
            >
                Depuis {dayjs(order.cancellation_requested_at).locale('fr').fromNow(true)}
            </time>
            <div className="text-xs leading-5 text-gray-500">
                {CANCELLATION_REASONS[order.cancellation_reason] ?? order.cancellation_reason ?? '—'}
            </div>

        </div>
    )
}

const columns = [
    {
        key: 'name',
        name: 'Commande / client',
        display: 'mandatory',
        sortable: true,
        component: (order) => (
            <div className="table-cell px-5 py-3 align-top whitespace-nowrap">
                <Anchor component={Link} to={`/orders/${order.id}`} fw={600} size="sm">
                    {order.name}
                </Anchor>
                <div className="mt-1 text-sm text-gray-700">{order.customer_name || '—'}</div>
                {order.created_at && (
                    <div className="mt-1 text-xs text-gray-500">
                        Commande du {dayjs(order.created_at).locale('fr').format('D MMM YYYY')}
                    </div>
                )}
            </div>
        ),
    },
    {
        key: 'cancellation_requested_at',
        name: 'Demande d’annulation',
        display: 'optional_default',
        sortable: true,
        component: CancellationRequestCell,
    },
    {
        key: 'preparations',
        name: 'Articles restant à expédier',
        display: 'optional_default',
        component: CancellationOrderDetails,
    },
    {
        key: 'cancellation_ticket_id',
        name: 'Ticket Gorgias',
        display: 'optional_default',
        component: (order) => (
            <div className="table-cell px-5 py-3 align-top whitespace-nowrap">
                {order.cancellation_ticket_id ? (
                    <Button
                        component="a"
                        href={`https://balticwatches.gorgias.com/app/ticket/${order.cancellation_ticket_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="subtle"
                        size="compact-xs"
                        fw={500}
                        leftSection={<IconMessageCircle size={14} aria-hidden="true" />}
                        rightSection={<IconExternalLink size={13} aria-hidden="true" />}
                    >
                        #{order.cancellation_ticket_id}
                    </Button>
                ) : <span className="text-xs text-gray-500">Aucun ticket</span>}
            </div>
        ),
    },
]

export default function CancellationRequestsPage() {
    return (
        <div>
            <Breadcrumbs breadcrumbs={[
                { label: 'Service après-vente', href: '/service-cases' },
                { label: 'Demandes d’annulation' },
            ]} />
            <Table
                availableColumns={columns}
                engineApiEndpoint="/orders/cancellation-requests"
                defaultSortColumn="cancellation_requested_at"
                defaultSortDirection="asc"
                searchable
                linkItemId="id"
                linkItemUrl="/orders"
            />
        </div>
    )
}
